import React from "react";
import {
  Grid,
} from '@chakra-ui/react';

import Header from "../../components/Productos/Tributario/Header"
import Modulos from "../../components/Productos/Tributario/Modulos"
import Otros from "../../components/Productos/Tributario/Otros"
// import Contactanos from "../../components/Shared/Contactanos"

export default function Tributario() {

  return (
    <Grid>
      <Header />
      <Modulos />
      <Otros />
      {/* <Contactanos /> */}
    </Grid >
  );
}
